"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseFilters = void 0;
var _zod = require("zod");
var _logger = require("../../../logger");
// TODO use @ori/presentation-query-state not ESM only
const filterSchema = _zod.z.object({
    name: _zod.z.string(),
    keys: _zod.z.array(_zod.z.string()).min(1)
});
const parseFilters = (value, allowedFacets)=>{
    const parseFiltersLogger = _logger.mainLogger.createChild('parseFilters');
    return value ? value.split(';').flatMap((part)=>{
        const [name, keys] = part.split(':');
        const allowedFacet = allowedFacets.find((facet)=>facet.name === name);
        if (!allowedFacet || !name) {
            parseFiltersLogger.error(new Error("Invalid facet name: ".concat(name)));
            return [];
        }
        const validKeys = keys ? keys.split(',').filter((key)=>allowedFacet.keys.includes(key)) : [];
        const validationResult = filterSchema.safeParse({
            name,
            keys: validKeys
        });
        if (!validationResult.success) {
            parseFiltersLogger.error(new Error(validationResult.error.message, {
                cause: validationResult.error
            }));
            return [];
        }
        return {
            name,
            keys: validKeys
        };
    }) : [];
};
exports.parseFilters = parseFilters;
